import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const LookUserHeader = (props) => {

  const {onBackClick} = props;

  return (
    <header className="ll-header">
      <Button className={"look-button look-button--secondary"}
              startIcon={<ChevronLeftIcon />}
              onClick={onBackClick}>
        <FormattedMessage id="look.backButton"/>
      </Button>
    </header>
  )
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookUserHeader)
)
